export const updateElementTabIndex = (element, isVisible)=>{
    // console.log("-----ELEMENT NAME (TABINDEX)-----:", element)
    const focusableElements = element.querySelectorAll('a, button, input, select, textarea');
    // console.log("TABINDEX:", focusableElements)
    focusableElements.forEach((el)=>{
        if (isVisible) {
            // console.log("REMOVING TABINDEX from: ", el)
            el.removeAttribute('tabindex');
        } else {
            // console.log("SETTING TABINDEX -1 to: ", el)
            el.setAttribute('tabindex', '-1');
        }
    });
};
